import { useEffect } from "react";

/**
 * Syncs horizontal scroll between the sticky header and the table body container.
 * The header sits outside .table-container (so CSS sticky works),
 * but must scroll horizontally in sync with the table body.
 *
 * Uses translateX instead of scrollLeft because the header uses overflow-x: clip
 * (to allow dropdown menus to overflow vertically without being clipped).
 */
export const useStickyHeader = (
  containerRef: React.RefObject<HTMLDivElement | null>
) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const header = container.querySelector<HTMLElement>(".table-sticky-header");
    const tableContainer = container.querySelector<HTMLElement>(".table-container");
    if (!header || !tableContainer) return;

    const headerInner = header.firstElementChild as HTMLElement | null;
    if (!headerInner) return;

    const syncHeaderFromTable = () => {
      headerInner.style.transform = `translateX(${-tableContainer.scrollLeft}px)`;
    };

    tableContainer.addEventListener("scroll", syncHeaderFromTable);

    // Initial sync
    syncHeaderFromTable();

    return () => {
      tableContainer.removeEventListener("scroll", syncHeaderFromTable);
    };
  }, [containerRef]);
};
